import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const MenuItem = ({ text, to, icon = "", collapse = false, children, isActive = false, ...rest }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItem disablePadding className={`!block ${isActive ? "bg-slate-400" : ""}`}>
        {to ? (
          <Link to={to}>
            <ListItemButton>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </Link>
        ) : (
          <ListItemButton onClick={handleClick} {...rest}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  );
};

export default MenuItem;
